const workoutStepperTranslations = {
  breakWeightPopUp: {
    newRecord: "رقم قياسي جديد",
    congratulations: `تهانينا! لقد نجحت في كسر الرقم القياسي الأخير الخاص بك.
        والآن يمكنك زيادة الوزن لكل مجموعة.`,
    keepItUp: "استمر",
  },
  cardioExercises: {
    select: "اختر أحد تمارين الكارديو",
  },
  dropsetPopUp: {
    title: "Dropset Expliantion",
    actionButton: "الغاء",
  },
  supersetExplainationPopUp: {
    title: "شرح السوبرسيت",
    actionButton: "اغلاق",
  },
  exercisesCard: {
    set: "مجموعة",
    lastSet: "المجموعة الأخيرة هي مجموعة الإسقاط",
    lastAchieved: "آخر ما تم تحقيقه",
    actionButton: "حفظ",
    warmUpSet: "مجموعة الاحماء",
  },
  exerciseRecordNotice: {
    notice: "ملاحظة",
    newRecord: "لديك رقم قياسي جديد",
    wrongTrack: "أنت على المسار الخاطئ",
    moreReps:
      "لقد قمت بعدد مرات تكرار أكثر من عدد مرات تكرارك/تمرينك، لذا يمكنك الآن زيادة وزنك/مجموعتك.",
    lessReps: `للاسف لقد قمت بعدد أقل من التكرارات/التمارين، من فضلك
        استخدم أوزانًا أخف لتجنب الإصابات وتحقيق تقدم أفضل.`,
    actionButton: "الغاء",
  },
  resetWorkoutRoutinePopUp: {
    title: "ملاحظة اعادة تعيين التدريبات",
    description: `أنت على وشك إعادة  أسبوع التمرين، مما يعني أنك ستبدأ من اليوم الأول في أسبوع التمرين`,
    actionButton: "الغاء",
    reset: "اعادة تعيين تدريبي",
  },
  routineCompleted: {
    congratulations: "تهانينا !",
    suffer: '"تعاني من ألم الانضباط ام تعاني من ألم الندم"',
    complete: `لقد اكتمل للتو يوم تدريب آخر، مما يعني أنك أقرب إلى هدفك.`,
  },
  strengthExercisePopUp: {
    title: "ملاحظات التمرين",
    noNotes: "ليس لديك أي ملاحظات لهذا اليوم",
    dtails: "تفاصيل التمرين",
    dropsetNotice: "Dropset Notice",
  },
  supersetWrapper: {
    title: "ملاحظات الدعم",
    read: "لقد قرأت",
  },
  warmUpCardioExercisePopUp: {
    actionButton: "تم",
  },
  z: {
    title: "ابدأ التمرين",
  },
};

export default workoutStepperTranslations;
